var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#A7A8CA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6188 16L25.8219 6.22188C25.9594 6.05938 25.8438 5.8125 25.6313 5.8125H23.1375C22.9906 5.8125 22.85 5.87812 22.7531 5.99062L15.9875 14.0562L9.22188 5.99062C9.12813 5.87812 8.98751 5.8125 8.83751 5.8125H6.34376C6.13126 5.8125 6.01563 6.05938 6.15313 6.22188L14.3563 16L6.15313 25.7781C6.12233 25.8143 6.10257 25.8586 6.0962 25.9058C6.08982 25.9529 6.0971 26.0008 6.11717 26.0439C6.13724 26.087 6.16926 26.1235 6.20943 26.1489C6.24959 26.1744 6.29621 26.1878 6.34376 26.1875H8.83751C8.98438 26.1875 9.12501 26.1219 9.22188 26.0094L15.9875 17.9438L22.7531 26.0094C22.8469 26.1219 22.9875 26.1875 23.1375 26.1875H25.6313C25.8438 26.1875 25.9594 25.9406 25.8219 25.7781L17.6188 16Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.12e493f7.svg";
export { ForwardRef as ReactComponent };